var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('Login',{ref:"reader",attrs:{"radioGroupClass":true,"size":"lg","labelForAuth":true},on:{"onDetection":_vm.onDetection,"updateModel":_vm.updateModel}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }